@if (alertRecargaCerta) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/inconsistencia.png" alt="Representa inconsistencia" width="82px">
      <p class="titulo-alert titulo-alert-erro mt-4 c-danger"> {{ tituloMensagemErro }} </p>
      <div class="footer-alert bg-white-outline">
        <p class="subtitulo mt-3"> {{ mensagemErro }} </p>
        <button class="botao-secundario me-3" (click)="ativarRecargaCerta()" [tag]="addTagManagerInteraction('box:button:click', 'sim')">SIM</button>
        <button class="botao-secundario-outline me-3" (click)="continuarSemRecargaCerta()" [tag]="addTagManagerInteraction('box:button:click', 'nao')">NÃO</button>
      </div>
    </div>
  </div>
}


